import React, { useEffect } from 'react'

import { AppAntSwitch } from '@components'
import { showDropoffOffice, officesPickoff } from '@signals'


export default function AppCommonFiltersShowDropoffOffices({ ...props }) {

	useEffect(() => {
		if(officesPickoff.value) showDropoffOffice.value = true
	}, [officesPickoff.value])

	return <AppAntSwitch
		trueText="Show Dropoff Office"
		checked={showDropoffOffice.value}
		onChange={newValue => showDropoffOffice.value = newValue.target.checked}
		{...props}
	/>
}